<template>
  <div>
    <GlobalTable
      :title="title+' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="false"
      :isLoading="isLoading"
      @addForm="addForm"
      @editForm="editForm"
    ></GlobalTable>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{title}}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CForm>
          <CRow>
            <CCol sm="6">
              <CInput
                label="Status Name"
                invalid-feedback="Status name should be filled"
                required
                v-model="$v.deliveryTypeStatusForm.name.$model"
                :is-valid="!$v.deliveryTypeStatusForm.name.$invalid"
              />
            </CCol>
          </CRow>

            <CRow>
            <CCol sm="6">
              <CTextarea
                label="Deskripsi"
                invalid-feedback="Status name should be filled"
                required
                v-model="$v.deliveryTypeStatusForm.description.$model"
                :is-valid="!$v.deliveryTypeStatusForm.description.$invalid"
                rows="4"
              />
            </CCol>
          </CRow>

        </CForm>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.deliveryTypeStatusForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import Loading from "../../../templates/Loading";

export default {
  name: "deliveryTypeStatus",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "Delivery Type Status",
      fields: [
        { key: "name", label: "Status", sorter: true },
        { key: "description", label: "Deskripsi", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
      items: [],
      deliveryTypeStatusForm: tableInterfaces.delivery_type_status,
      isLoading: false,
      addButton: false,
      isEdit: false,
    };
  },
  validations: {
    deliveryTypeStatusForm: {
      name: { required },
      description : { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getDeliveryTypeStatus();
    },
    getDeliveryTypeStatus: function () {
      this.isLoading = true;
      this.axios
        .get("console/master/delivery_type/status/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.deliveryTypeStatusForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.province) {
        tableInterfaces.province[i] = null;
      }
      this.deliveryTypeStatusForm = tableInterfaces.province;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (this.isEdit === true) {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/master/delivery_type/status/edit", this.deliveryTypeStatusForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      } else {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post("console/master/delivery_type/status/add", this.deliveryTypeStatusForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
